/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Brand_RetailInputs */

const en_price_brand_retail = /** @type {(inputs: Price_Brand_RetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand retail`)
};

/**
* | output |
* | --- |
* | "Brand retail" |
*
* @param {Price_Brand_RetailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_brand_retail = /** @type {((inputs?: Price_Brand_RetailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Brand_RetailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_brand_retail(inputs)
});